export default {
  name: 'project_invite_emails',
  component_path: 'modules/procedures/blocks/create_invite/BlockCreateProjectnviteEmails'
}